import type { PositionsView } from "@/api";
import type { Lang, TFunc } from "../../i18n";

type ExtrasOutcome = NonNullable<PositionsView["extras_eligibility"]>;
type ExtrasReason = NonNullable<PositionsView["extras_reason_code"]>;

const OUTCOME_KEYS: Record<ExtrasOutcome, string> = {
  ELIGIBLE: "ws.extrasEligibility.eligible",
  INELIGIBLE: "ws.extrasEligibility.ineligible",
  UNRESOLVED: "ws.extrasEligibility.unresolved",
};

const REASON_KEYS: Record<ExtrasReason, string> = {
  MEETS_EXTRAS_MINIMUM: "ws.extrasReason.meetsMinimum",
  BELOW_EXTRAS_MINIMUM: "ws.extrasReason.belowMinimum",
  FOOD_SUBTOTAL_UNAVAILABLE: "ws.extrasReason.subtotalUnavailable",
  FACTS_REQUIRE_REVIEW: "ws.extrasReason.factsRequireReview",
};

export function extrasEligibilityDiagnostic(
  positions: PositionsView | null,
  t: TFunc,
  lang: Lang,
): string | null {
  const outcome = positions?.extras_eligibility;
  const reason = positions?.extras_reason_code;
  const threshold = positions?.extras_threshold_net_eur;
  if (!outcome || !reason || typeof threshold !== "number") return null;

  const currency = new Intl.NumberFormat(lang === "de" ? "de-DE" : "en-GB", {
    style: "currency",
    currency: "EUR",
  });
  const subtotal = typeof positions.estimated_food_total_net === "number"
    ? currency.format(positions.estimated_food_total_net)
    : t("ws.extrasSubtotalUnavailable");

  return t("ws.extrasEligibilityDiagnostic", {
    status: t(OUTCOME_KEYS[outcome]),
    reason: t(REASON_KEYS[reason]),
    subtotal,
    threshold: currency.format(threshold),
  });
}
